/* --- IMAGES & ASSETS --- */
import softwareImg from "../pictures/software.jpg";
import digitalImg from "../pictures/digital.jpg";
import automationImg from "../pictures/branding.jpg"; // Using branding asset for automation matrix
import startupImg from "../pictures/registration.jpg"; // Using registration asset for startup launch
import brandingImg from "../pictures/branding.jpg";      // Added missing reference import
import soft from "../pictures/software.jpg";            // Added missing reference import
import giftImg from "../pictures/gift.jpg";   
import ai from "../pictures/Ai.jpg"       // Added missing reference import
const serviceDetailsData = {

  /* =====================================================
      1. IT & SOFTWARE DEVELOPMENT
  ===================================================== */
  "Digital Product Engineering": {
    metaTitle: "IT Services & Custom Software Development | FKODE Solutions",
    metaDescription: "Design and develop websites, scalable applications, and enterprise software solutions tailored to power business growth.",
    image: softwareImg,
    h1: "IT & Software Development",
    intro: "Building Digital Solutions That Power Business Growth. Every successful business needs a strong digital foundation. At FKODE, we design and develop websites, applications, and software solutions that help businesses operate efficiently, serve customers better, and scale confidently.",
    
    sections: [
      {
        title: "What We Develop",
        content: "Whether you're launching a startup, digitizing legacy operations, or creating a new software product, our engineering team delivers high-concurrency solutions tailored to your targets.",
        list: [
          "Business Websites (Establish credibility & generate premium inquiries)",
          "Web Applications (Custom web platforms built to streamline workflows)",
          "Mobile Applications (Android & iOS seamless user experiences)",
          "SaaS Products (Subscription platforms engineered for scaling recurring revenue)",
          "Custom Software Solutions (Tailor-made for unique business processes)",
          "CRM & ERP Systems (Centralized systems to manage customer and stock data)"
        ]
      },
      {
        title: "Our Development Approach",
        content: "We balance premium performance with bulletproof software engineering architecture rules to ensure zero downtime and slick interactive speeds.",
        list: [
          "User-Centered Creative Design Layouts",
          "Secure Development & Encrypted Data Practices",
          "Mobile-First Responsive Interface Experience",
          "Scalable & Clean Architecture Patterns",
          "Fast Performance Optimization Engine Tracking",
          "Ongoing SLA Support & Ecosystem Maintenance"
        ]
      },
      {
        title: "Ideal Enterprise Audiences",
        content: "Our custom frameworks adapt symmetrically across vertical sectors, ensuring high operational efficiency regardless of corporate industry bounds.",
        list: [
          "Early Stage Startups & Disruptors",
          "Small & Medium Enterprises (SMEs)",
          "Large Scale Corporate Organizations",
          "Healthcare & Medical Clinic Establishments",
          "Educational Institutes & Academy Platforms",
          "Service-Based Companies & Agencies"
        ]
      }
    ],
    ctaText: "Start Your Project",
    ctaLink: "/contact"
  },

  /* =====================================================
      2. DIGITAL MARKETING & LEAD GENERATION
  ===================================================== */
  "Growth & Customer Acquisition": {
    metaTitle: "Digital Marketing & Performance Lead Generation | FKODE Solutions",
    metaDescription: "Attract more customers and generate more revenue with data-driven marketing funnels and automated loops.",
    image: digitalImg,
    h1: "Digital Marketing & Lead Generation",
    intro: "Attract More Customers. Generate More Revenue. Having a great product or service isn't enough. Businesses need deep visibility, hyper-engagement, and a reliable automated system that consistently turns interest into paying clients.",
    
    sections: [
      {
        title: "Our Digital Marketing Services",
        content: "At FKODE, we create data-driven marketing strategies that help businesses systematically expand brand authority thresholds and convert active traffic lanes.",
        list: [
          "Search Engine Optimization (SEO to attract active keyword search traffic)",
          "Social Media Marketing (Build visibility & audience engagement layers)",
          "Performance Advertising (Targeted campaigns delivering measurable ROI calculations)",
          "Lead Generation Systems (Automated funnels capturing high-value pipeline metrics)",
          "WhatsApp Marketing (Direct personalized communication loops & automation updates)",
          "Email Marketing (Build lasting relationships through smart drip automations)"
        ]
      },
      {
        title: "What You Gain",
        content: "We optimize conversion pathways across distinct tracking modules so your customer acquisition expense ratios scale down consistently.",
        list: [
          "More Qualified Top-Tier Lead Flow",
          "Significantly Higher Conversion Rates",
          "Elevated Global & Local Brand Visibility",
          "Deepened Customer Interaction Engagement",
          "Measurable, Transparent Marketing Performance Metrics",
          "Sustainable & Predictable Business Growth Loops"
        ]
      },
      {
        title: "Our Analytical Growth Process",
        content: "We avoid speculative planning metrics. Every campaign deployment scales step-by-step through strict iterative validation milestones.",
        list: [
          "01. In-Depth Market & Competitor Research",
          "02. Multi-Channel Strategy Planning & Allocation",
          "03. High-Conversion Campaign Execution Layer",
          "04. Centralized End-to-End Lead Tracking Synchronization",
          "05. Real-Time Performance Optimization Audits",
          "06. Continuous Organic & Paid Growth Scaling"
        ]
      }
    ],
    ctaText: "Start Your Growth Journey",
    ctaLink: "/contact"
  },

  /* =====================================================
      3. BUSINESS AUTOMATION & AI SOLUTIONS
  ===================================================== */
  "Intelligent Automation Systems": {
    metaTitle: "Intelligent Business Automation & AI Solutions | FKODE Solutions",
    metaDescription: "Work smarter and scale faster by automating repetitive tasks through neural chatbots, workflow loops, and dashboard tracking.",
    image: ai,
    h1: "Business Automation & AI Solutions",
    intro: "Work Smarter. Scale Faster. Businesses waste valuable time on repetitive manual tasks that can be fully automated. FKODE helps organizations improve operational efficiency, minimize workload stress, and enhance client satisfaction loops.",
    
    sections: [
      {
        title: "Intelligent Automation Services",
        content: "Our deep solutions allow your internal leadership core to focus entirely on vision expansion while technology stacks execute routine micro-operations autonomously.",
        list: [
          "AI Chatbots (Provide instant support and resolve user inquiries 24/7/365)",
          "WhatsApp Automation (Automate message updates, follow-ups, and lead qualifications)",
          "Workflow Automation (Eliminate manual steps by linking internal software layers)",
          "Lead Management Automation (Capture, organize, track, and route leads automatically)",
          "Appointment & Booking Systems (Seamless scheduling grids with zero manual alignment)",
          "Business Intelligence Dashboards (Monitor key analytics through live centralized views)"
        ]
      },
      {
        title: "Measurable Benefits of Automation",
        content: "Deploying logical workflow models into legacy ecosystems produces immediate structural operational velocity gains.",
        list: [
          "Ultra-Fast Customer Response Response Times",
          "Drastically Reduced Overhead & Operational Costs",
          "Enhanced Internal Team Productivity Ratios",
          "Slick, Error-Free Consumer Experience Foundations",
          "Elevated Operational Output Efficiency Rates",
          "Infinitely Scalable Business Pipeline Layouts"
        ]
      },
      {
        title: "AI-Powered Business Growth",
        content: "We combine modern machine learning technologies, specialized language patterns, and automated actions into single unified frameworks built to output measurable metrics.",
        list: [
          "24/7 Autonomous Customer Engagement Touchpoints",
          "Self-Correcting Internal Pipeline Systems",
          "Data-Driven Operational Diagnostics",
          "Unfair Competitive Advantages Across Modern Scale Spaces"
        ]
      }
    ],
    ctaText: "Book a Consultation",
    ctaLink: "/contact"
  },

  /* =====================================================
        4. STARTUP & BUSINESS LAUNCH SOLUTIONS
    ===================================================== */
    "Startup & Business Launch Solutions": {
      metaTitle: "Startup & Business Launch Solutions | Complete Incubation Support",
      metaDescription: "From raw concept and corporate registration to branding identity assets, MVP software build, and growth frameworks.",
      image: startupImg,
      h1: "Startup & Business Launch Solutions",
      intro: "Turn Your Raw Idea Into a Real Business. Many great ideas never cross the execution gap because founders struggle with structured planning, elite branding identity designs, clean code development, and strategic marketing scaling. FKODE bridges that gap entirely.",
      
      sections: [
        {
          title: "What We Help With",
          content: "Whether you have an application idea, SaaS software framework, decentralized marketplace platform, healthcare clinic solution, or local enterprise going global — we deliver end-to-end setups.",
          list: [
            "Idea Validation & Architecture Mapping (Transform raw ideas into real structures)",
            "Business Registration Support (Guidance through compliance filing steps cleanly)",
            "Premium Branding & Identity (Abstract logo layouts, font kits, and corporate guides)",
            "Rapid MVP Development (Engineer and deploy version-01 products with speed)",
            "Website & Application Base Setup (Establish robust structural infrastructure grids)",
            "Post-Launch Growth Strategy (Generate organic visibility pipelines immediately)"
          ]
        },
        {
          title: "Our Business Building Matrix Process",
          content: "We guide founders through an optimization flow that reduces overall capital exposure risk while accelerating market rollout velocity.",
          list: [
            "💡 Concept Incubation & Verification ↓",
            "📋 Operational Execution Strategy Formulation ↓",
            "🎨 Premium Abstract Brand Identity Creation ↓",
            "💻 Agile Software & Cloud Architecture Development ↓",
            "🚀 High-Impact Public Production Launch ↓",
            "📈 Data-Driven Metric Optimization & Growth Scaling"
          ]
        },
        {
          title: "Why Founders Choose FKODE",
          content: "Most agencies handle single detached shards of the matrix puzzle. FKODE serves as a long-term co-engineering enterprise partner mapping your lifecycle cleanly from inception up to active market domain victory.",
          list: [
            "Unified lifecycle tracking under a single corporate roof",
            "Startup-optimized investment configurations",
            "Elite minimalist visual aesthetics paired with lightning fast code layouts",
            "Direct access to tactical technical support assets"
          ]
        }
      ],
      ctaText: "Book a Discovery Call",
      ctaLink: "/contact"
    
  },

  
  /* =====================================================
      8. BUSINESS REGISTRATION & COMPLIANCE
  ===================================================== */
  "registration": {
    metaTitle: "Company Registration & Business Compliance Services | FKode Solutions",
    metaDescription: "Fast, secure corporate registration and legal business filing services. Launch your startup seamlessly with Chennai-based compliance engineering experts.",
    image: startupImg, // Maps cleanly to your imported launch layout asset
    h1: "Company Registration & Compliance",
    intro: "Transform legal frameworks into operational acceleration structures. FKode Solutions streamlines complex corporate registration, licensing pipelines, and financial filing steps so founders can focus on scaling vision metrics with maximum security.",
    
    sections: [
      {
        title: "Comprehensive Corporate Setup Services",
        content: "We manage structural verification and deployment steps across corporate authorities to build a clean legal launchpad for your business.",
        list: [
          "Private Limited (Pvt Ltd) Company Incorporation Tracking",
          "Limited Liability Partnership (LLP) Structural Framework Filing",
          "One Person Company (OPC) & Sole Proprietorship Asset Setup",
          "GST Registration, Tax Structure Alignment & Token Setup",
          "MSME/Udyam Certification & Government Portal Onboarding",
          "Corporate Trademark Filing & Intellectual Property Guard Infrastructure"
        ]
      },
      {
        title: "Symmetric Regulatory Pipeline",
        content: "Our validation layers ensure document assets compile cleanly without rejection intervals, accelerating validation metrics through government nodes.",
        list: [
          "Phase 1: Direct Name Availability Verification & Verification Setup",
          "Phase 2: High-Fidelity Document Processing & Digital Signature (DSC) Setup",
          "Phase 3: Formal Corporate Draft (MOA/AOA) Engineering Layouts",
          "Phase 4: Final Certificate of Incorporation (COI) Delivery and Deployment"
        ]
      },
      {
        title: "Why Engineers & Founders Choose FKode Compliance",
        content: "We bypass standard agency friction loops. Our process blends rapid document execution speeds with startup-optimized architectural investment setups.",
        list: [
          "Highly expert Chennai-based legal engineering asset team",
          "Zero hidden friction fees or unstructured pricing overheads",
          "Seamless end-to-end alignment with our main MVP software tracks",
          "Continuous corporate post-incorporation maintenance and support grids"
        ]
      }
    ],
    ctaText: "Launch Your Business",
    ctaLink: "/contact"
  },

  /* =====================================================
      5. DESIGN & BRANDING
  ===================================================== */
  "branding": {
    metaTitle: "Branding & Creative Design Services Worldwide | FKode Solutions",
    metaDescription: "Professional branding and design services for businesses worldwide. Logo, brand identity, packaging & creatives by Chennai-based experts.",
    image: brandingImg,
    h1: "Branding and Design Services",
    intro: "FKode Solutions delivers premium corporate identity assets that elevate consumer perception metrics. We transform abstract brand ideals into high-impact visual design grids across online and physical channels.",
    
    sections: [
      {
        title: "Our Creative Design Services",
        content: "We design complete visual frameworks to ensure businesses maintain strong, highly recognizable presence layouts. Our designers establish deep uniformity lines across all operational assets.",
        list: [
          "Premium Abstract Logo Design & Identities",
          "Unified Brand Kits (Fonts, Custom Color Palettes)",
          "Corporate Style Guides & Brand Guidelines",
          "Business Cards, Brochures & Marketing Layouts",
          "Custom Menu, Graphics, & Product Packaging",
          "High-impact Social Media Creative Layouts"
        ]
      },
      {
        title: "The Visual Identity Process",
        content: "Our systemized design approach extracts core visual patterns before drafting assets, allowing zero room for misalignment between identity systems and intended audience niches.",
        list: [
          "Phase 1: Deep Brand Discovery & Analysis",
          "Phase 2: Concept Creation & Architecture",
          "Phase 3: High-fidelity Design & Refinement",
          "Phase 4: Structured Final Asset Kit Delivery"
        ]
      },
      {
        title: "Why FK Design Engineering",
        content: "We focus on commercial aesthetics. Every graphic system, custom token asset, and typography line we configure serves to establish premium industry-standard presence.",
        list: [
          "Business-focused creative design execution",
          "Ultra-modern premium minimalist aesthetics",
          "Remote-friendly global operational workflows",
          "Rapid turnaround times with absolute consistency"
        ]
      }
    ],
    ctaText: "Elevate Your Brand",
    ctaLink: "/contact"
  },

  
  /* =====================================================
      7. CORPORATE GIFTING SOLUTIONS
  ===================================================== */
  "gifting": {
    metaTitle: "Corporate Gifting Solutions Worldwide | FKode Solutions",
    metaDescription: "Custom corporate gifting solutions for businesses worldwide. Employee kits, promotional gifts & bulk orders from Chennai-based experts.",
    image: giftImg,
    h1: "Corporate Gifting Solutions",
    intro: "Strengthen business relationships and elevate brand allegiance. We design and distribute premium, high-quality personalized corporate gifts that turn normal client connections into long-term brand equity.",
    
    sections: [
      {
        title: "Our Gifting Catalog Profiles",
        content: "We provide extensive choices for elite corporate distribution, ensuring every single item mirrors the aesthetic qualities and values of your professional establishment.",
        list: [
          "Custom Corporate Apparel & Premium T-Shirts",
          "Custom Mugs, Executive Stationery & Media Items",
          "Onboarding Employee Welcome Kits & Bundles",
          "High-end Festival & Event Gift Box Packages",
          "Promotional Event Products & Distribution Items",
          "Bulk Corporate Asset Orders with Quality Control"
        ]
      },
      {
        title: "Symmetric Management Pipeline",
        content: "From initial sample selection down to final multi-location logistics, our processes guarantee quality verification so kits arrive completely intact and beautifully arranged.",
        list: [
          "Target Requirement & Brand Alignment Discussion",
          "Premium Product Curations & Custom Token Selection",
          "High-fidelity Logo Customization & Rigid Quality Check",
          "On-time Logistics Management & Verified Distribution"
        ]
      },
      {
        title: "Why FK Gifting Operations",
        content: "We handle corporate packaging with deep attention to detail. Our scalable pricing systems help organizations execute massive distribution campaigns efficiently.",
        list: [
          "Premium-grade luxury material selections",
          "Precise corporate branding layout fidelity",
          "Highly competitive bulk pricing configurations",
          "Reliable global and local delivery infrastructures"
        ]
      }
    ],
    ctaText: "Request Bulk Quote",
    ctaLink: "/contact"
  }
};

export default serviceDetailsData;
